const {Component} = require("react");
const PropTypes = require("prop-types");
const Link = require("app/components/mixins/Link");

class List extends Component {

	static get propTypes() {
		return {
			title: PropTypes.string,
			subtitle: PropTypes.string,
			items: PropTypes.array
		};
	}

	static get defaultProps() {
		return {
			title: "Static grouped list",
			subtitle: "Grouped list",
			items: []
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			activeGroup: 0
		};
	}

	get className() {
		return "grouped-list static-grouped-list";
	}

	getGroupLink(item) {
		return item.link || "#";
	}

	setGroup(index) {
		this.setState({activeGroup: index});
	}

	_groupClickListener(index) {
		return () => {
			this.setGroup(index);
		};
	}

	renderHeader() {
		return (
			<div className="header">
				<div className="title">
					<div className="subtitle">{this.props.subtitle}</div>
					<h2>{this.props.title}</h2>
				</div>
				<div className="group-toggles">{this.renderGroupTriggers()}</div>
			</div>
		);
	}

	renderGroupTriggers() {
		return this.props.items.map((item, i) => {
			let className = i === this.state.activeGroup ? "active" : "";
			return (
				<Link key={i} className={className} href={this.getGroupLink(item)}
							onClick={this._groupClickListener(i)}>{item.title}</Link>
			);
		});
	}

	renderGroups() {
		return this.props.items.map((item, i) => {
			let classList = ["group"];

			if (i === this.state.activeGroup) {
				classList.push("active");
			}

			return (
				<div key={i} className={classList.join(" ")}>
					{this.renderGroup(item)}
				</div>
			);
		});
	}

	render() {
		return (
			<div className={this.className}>
				{this.renderHeader()}
				<div className="body">{this.renderGroups()}</div>
			</div>
		);
	}
}

module.exports = List;
